/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { FormElementProps } from '@/auth/types';
import { Input } from '@adobe-commerce/elsie/components';
import { memo } from 'preact/compat';
import { FieldElement } from './FieldElement';

export const InputElement = memo(
  ({
    item,
    valueMessage,
    errorConfig,
    onBlur,
    onChange,
    onFocus,
    className,
    itemClassName,
    loading,
  }: FormElementProps) => {
    return (
      <FieldElement
        item={item}
        errorConfig={errorConfig}
        className={className}
        itemClassName={itemClassName}
        loading={loading}
      >
        <Input
          type="text"
          name={item.customUpperCode}
          value={valueMessage ?? item.defaultValue}
          placeholder={item.label}
          floatingLabel={`${item.label} ${item.required ? '*' : ''}`}
          autocomplete={item.autocomplete}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
        />
      </FieldElement>
    );
  }
);
